import React, { useEffect, useLayoutEffect, useState } from "react";
import Footer from '../component/Footer';
import baseURL from "../component/baseURL";
import stringsoflanguages from "../component/stringsoflanguages";

export default function MainSidebar({ activeItem, setActiveItem }) {

    const [userID, setUserID] = useState(null);
    const [myConCount, setMyConCount] = useState(0);
    const [connRequtCount, setConnRequtCount] = useState(0);
    const [totalMembersCount, setTotalMembersCount] = useState(0);
    const [memCount, setMemCount] = useState(0);
    const [memberFilterStatus, setMemberFilterStatus] = useState(0);
    const [myConnFilterStatus, setMyConnFilterStatus] = useState(0);
    const [myListingCount, setMyListingCount] = useState(0);
    const [myPortfolioCount, setMyPortfolioCount] = useState(0);
    const [portfolioPoolCount, setPortfolioPoolCount] = useState(0);
    const [poolFilter, setPoolFilter] = useState(0);
    const [listingFilter, setListingFilter] = useState(0);
    const [portfolioFilterStatus, setPortfolioFilterStatus] = useState(0);
    const [sidebarEnter, setSidebarEnter] = useState(
        () =>
            typeof window !== "undefined" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );

    useLayoutEffect(() => {
        if (sidebarEnter) return;
        let raf2;
        let startTimer;
        const raf1 = requestAnimationFrame(() => {
            raf2 = requestAnimationFrame(() => {
                startTimer = window.setTimeout(() => setSidebarEnter(true), 160);
            });
        });
        return () => {
            cancelAnimationFrame(raf1);
            if (raf2) cancelAnimationFrame(raf2);
            if (startTimer) clearTimeout(startTimer);
        };
    }, [sidebarEnter]);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);


        fetchMemberCount(userid);
        fetchPortfolioCount(userid);
    }, []);

    function fetchMemberCount(userid) {
        // console.log(this.state.userID)
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/member/count_members', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response
                console.log('Test*********************')
                console.log(result)
                if (responseJson.server.result_code === 200) {
                    const result = responseJson.response
                    console.log(result.member_counts.request_received)
                    setMyConCount(result.member_counts.my_connections)
                    setConnRequtCount(result.member_counts.request_received)
                    setTotalMembersCount(result.member_counts.total_members)
                    setMemCount(result.member_counts.unread_requests)
                    setMemberFilterStatus(result.member_counts.filter_on)
                    setMyConnFilterStatus(result.member_counts.my_connection_filter_on)

                }
                else {
                    console.log(responseJson.server.result_code)
                    // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }


    function fetchPortfolioCount(userid) {


        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/portfolio/portfolio_count', {
            method: 'POST',

            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (responseJson.server.code === 200) {

                    setMyListingCount(responseJson.response.my_listing.toString())
                    setMyPortfolioCount(responseJson.response.my_portfolio.toString())
                    setPortfolioPoolCount(responseJson.response.pool.toString())
                    setPoolFilter(responseJson.response.pool_filter)
                    setListingFilter(responseJson.response.my_listing_filter)
                    setPortfolioFilterStatus(responseJson.response.pool_filter)
                }
                else {
                    // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    return (
        <div
            className={`content-left main-sidebar${sidebarEnter ? " main-sidebar--visible" : ""}`}
        >
            <ul>
                <li>
                    <div
                        className={`nav-item ${activeItem === "My Connection" ? "active" : ""}`}
                        onClick={() => setActiveItem("My Connection")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{myConCount}</span>
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M9.94944 18.2927L7.12141 21.1207C5.94896 22.2932 4.05028 22.2932 2.87882 21.121C1.70713 19.9493 1.70713 18.0504 2.87859 16.8789L8.53564 11.2219C9.7071 10.0504 11.606 10.0504 12.7774 11.2219C13.1679 11.6124 13.8011 11.6124 14.1917 11.2219C14.5822 10.8314 14.5822 10.1982 14.1917 9.80767C12.2391 7.85513 9.07395 7.85513 7.12141 9.80767L1.46441 15.4647C-0.488136 17.4172 -0.488136 20.5824 1.46441 22.5349C3.41672 24.4885 6.58211 24.4885 8.53568 22.5349L11.3637 19.7069C11.7542 19.3164 11.7542 18.6832 11.3637 18.2927C10.9732 17.9021 10.34 17.9022 9.94944 18.2927Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M22.535 1.46441C20.5825 -0.488136 17.4163 -0.488136 15.4638 1.46441L12.0707 4.85743C11.6802 5.24794 11.6802 5.88114 12.0707 6.27165C12.4613 6.66217 13.0944 6.66217 13.485 6.27165L16.878 2.87863C18.0494 1.70713 19.9493 1.70713 21.1208 2.87863C22.2923 4.05009 22.2923 5.94896 21.1208 7.12042L14.8988 13.3425C13.7273 14.514 11.8284 14.514 10.657 13.3425C10.2665 12.952 9.63327 12.952 9.24275 13.3425C8.85223 13.733 8.85223 14.3662 9.24275 14.7567C11.1953 16.7093 14.3605 16.7093 16.313 14.7567L22.535 8.5347C24.4876 6.58216 24.4876 3.41695 22.535 1.46441Z"
                                        fill="white"
                                    />
                                </svg>
                            </span>
                            {stringsoflanguages.myconnection}
                        </div>
                        <div className="sidebar-filter-status flex flex-col text-center">
                            <span className="view-details">{stringsoflanguages.viewDetails}</span>
                            {myConnFilterStatus === 1 ? <span className="sidebar-filter-active">{stringsoflanguages.filterActive}</span> : null}
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Connection Request" ? "active" : ""}`}
                        onClick={() => setActiveItem("Connection Request")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{connRequtCount}</span>
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M8.75 11C11.3734 11 13.5 8.87335 13.5 6.25C13.5 3.62665 11.3734 1.5 8.75 1.5C6.12665 1.5 4 3.62665 4 6.25C4 8.87335 6.12665 11 8.75 11Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M15.34 12.4798C14.8017 11.6961 14.1071 11.0323 13.3 10.5298C12.7165 11.1517 12.0117 11.6473 11.2291 11.9862C10.4465 12.325 9.60278 12.4998 8.75 12.4998C7.89722 12.4998 7.05349 12.325 6.27092 11.9862C5.48834 11.6473 4.78353 11.1517 4.2 10.5298C3.22163 11.1296 2.41361 11.9705 1.85331 12.9721C1.29302 13.9736 0.999202 15.1022 1 16.2498V18.2498C1.00144 18.4483 1.08092 18.6382 1.22126 18.7785C1.3616 18.9189 1.55153 18.9983 1.75 18.9998H11.55C11.377 17.6475 11.6546 16.2759 12.3397 15.0973C13.0248 13.9187 14.0793 12.9987 15.34 12.4798Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M18 13.25C17.0605 13.25 16.1422 13.5286 15.361 14.0505C14.5799 14.5725 13.9711 15.3143 13.6116 16.1823C13.2521 17.0502 13.158 18.0053 13.3413 18.9267C13.5246 19.8481 13.9769 20.6945 14.6412 21.3588C15.3055 22.0231 16.1519 22.4754 17.0733 22.6587C17.9947 22.842 18.9498 22.7479 19.8177 22.3884C20.6857 22.0289 21.4275 21.4201 21.9495 20.639C22.4714 19.8578 22.75 18.9395 22.75 18C22.7485 16.7407 22.2476 15.5333 21.3572 14.6429C20.4667 13.7524 19.2593 13.2515 18 13.25ZM19.25 20C19.25 20.1989 19.171 20.3897 19.0303 20.5303C18.8897 20.671 18.6989 20.75 18.5 20.75C18.3011 20.75 18.1103 20.671 17.9697 20.5303C17.829 20.3897 17.75 20.1989 17.75 20V16.75H17.5C17.3011 16.75 17.1103 16.671 16.9697 16.5303C16.829 16.3897 16.75 16.1989 16.75 16C16.75 15.8011 16.829 15.6103 16.9697 15.4697C17.1103 15.329 17.3011 15.25 17.5 15.25H18.5C18.6989 15.25 18.8897 15.329 19.0303 15.4697C19.171 15.6103 19.25 15.8011 19.25 16V20Z"
                                        fill="white"
                                    />
                                </svg>
                            </span>
                            {stringsoflanguages.connectionRequest}
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item relative ${activeItem === "Global Members" ? "active" : ""}`}
                        onClick={() => setActiveItem("Global Members")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{totalMembersCount}</span>
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M6.02856 18.5144V19.6001C6.02856 19.744 6.08558 19.8824 6.18762 19.9839C6.28916 20.0859 6.42756 20.1429 6.57144 20.1429H17.4286C17.5724 20.1429 17.7108 20.0859 17.8124 19.9839C17.9144 19.8824 17.9714 19.744 17.9714 19.6001V18.5144C17.9714 16.9309 17.3423 15.412 16.2224 14.2921C15.1024 13.1721 13.5835 12.543 12 12.543C10.4165 12.543 8.89758 13.1721 7.77765 14.2921C6.65774 15.412 6.02856 16.9309 6.02856 18.5144Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M1.14288 20.1429H5.03623C4.97491 19.9703 4.94286 19.7868 4.94286 19.6V18.5143C4.94286 17.2745 5.26911 16.0682 5.87385 15.0107C5.42057 14.8196 4.92279 14.7144 4.39999 14.7144C2.30133 14.7144 0.600006 16.4157 0.600006 18.5143V19.6C0.600006 19.8997 0.843199 20.1429 1.14288 20.1429Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M19.6 14.7144C19.0772 14.7144 18.5794 14.8196 18.1262 15.0107C18.7309 16.0682 19.0572 17.2745 19.0572 18.5143V19.6C19.0572 19.7868 19.0251 19.9703 18.9638 20.1429H22.8571C23.1568 20.1429 23.4 19.8997 23.4 19.6V18.5143C23.4 16.4157 21.6987 14.7144 19.6 14.7144Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M6.29669 12.8563C7.36697 11.807 7.38398 10.0887 6.33469 9.01846C5.2854 7.94818 3.56715 7.93117 2.49687 8.98046C1.42659 10.0298 1.40958 11.748 2.45887 12.8183C3.50816 13.8886 5.22642 13.9056 6.29669 12.8563Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M21.5003 12.8618C22.5706 11.8124 22.5877 10.094 21.5383 9.02366C20.4889 7.95329 18.7705 7.93628 17.7001 8.98566C16.6297 10.035 16.6127 11.7535 17.6621 12.8238C18.7115 13.8942 20.4299 13.9112 21.5003 12.8618Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M12.6015 11.4042C14.6729 11.0705 16.0815 9.12083 15.7478 7.04947C15.4142 4.97811 13.4645 3.56945 11.3931 3.90314C9.32177 4.23682 7.91311 6.18649 8.2468 8.25785C8.58048 10.3292 10.5301 11.7379 12.6015 11.4042Z"
                                        fill="white"
                                    />
                                </svg>
                            </span>


                            {stringsoflanguages.globalMembers}
                        </div>
                        <div className="sidebar-filter-status flex flex-col text-center">
                            <span className="view-details">{stringsoflanguages.viewDetails}</span>
                            {memberFilterStatus === 1 ? <span className="sidebar-filter-active">{stringsoflanguages.filterActive}</span> : null}
                        </div>

                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "My Listings" ? "active" : ""}`}
                        onClick={() => setActiveItem("My Listings")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{myListingCount}</span>
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM9.97 14.9L7.72 17.15C7.57 17.3 7.38 17.37 7.19 17.37C7 17.37 6.8 17.3 6.66 17.15L5.91 16.4C5.61 16.11 5.61 15.63 5.91 15.34C6.2 15.05 6.67 15.05 6.97 15.34L7.19 15.56L8.91 13.84C9.2 13.55 9.67 13.55 9.97 13.84C10.26 14.13 10.26 14.61 9.97 14.9ZM9.97 7.9L7.72 10.15C7.57 10.3 7.38 10.37 7.19 10.37C7 10.37 6.8 10.3 6.66 10.15L5.91 9.4C5.61 9.11 5.61 8.63 5.91 8.34C6.2 8.05 6.67 8.05 6.97 8.34L7.19 8.56L8.91 6.84C9.2 6.55 9.67 6.55 9.97 6.84C10.26 7.13 10.26 7.61 9.97 7.9ZM17.56 16.62H12.31C11.9 16.62 11.56 16.28 11.56 15.87C11.56 15.46 11.9 15.12 12.31 15.12H17.56C17.98 15.12 18.31 15.46 18.31 15.87C18.31 16.28 17.98 16.62 17.56 16.62ZM17.56 9.62H12.31C11.9 9.62 11.56 9.28 11.56 8.87C11.56 8.46 11.9 8.12 12.31 8.12H17.56C17.98 8.12 18.31 8.46 18.31 8.87C18.31 9.28 17.98 9.62 17.56 9.62Z"
                                        fill="white"
                                    />
                                </svg>
                            </span>
                            {stringsoflanguages.mylistings}
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "My Portfolio" ? "active" : ""}`}
                        onClick={() => setActiveItem("My Portfolio")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{myPortfolioCount}</span>
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_459_2811)">
                                        <path
                                            d="M21.8891 5.14551H2.11078C0.947848 5.14551 0.00172453 6.09163 0.00172453 7.25457V10.582C-0.11807 13.9182 5.92251 15.3196 9.6068 15.5071C9.57816 15.3617 9.56279 15.2117 9.56279 15.0581V13.4411C9.56279 13.0529 9.87755 12.7381 10.2658 12.7381H13.734C14.1223 12.7381 14.4371 13.0529 14.4371 13.4411V15.0581C14.4371 15.2117 14.4217 15.3617 14.393 15.507C18.0752 15.3213 24.1215 13.9144 23.9981 10.582V7.25457C23.9981 6.09158 23.052 5.14551 21.8891 5.14551Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M7.26627 3.63268C7.26627 3.18757 7.62837 2.82547 8.07347 2.82547H15.9265C16.3715 2.82547 16.7336 3.18757 16.7336 3.63268V3.7394H18.1397V3.63268C18.1397 2.41228 17.1468 1.41943 15.9265 1.41943H8.07347C6.85308 1.41943 5.86023 2.41228 5.86023 3.63268V3.7394H7.26627V3.63268Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M13.4309 16.9688C13.0571 17.2266 12.6046 17.378 12.1171 17.378H11.8828C11.3954 17.378 10.9428 17.2266 10.569 16.9688C7.92582 16.8618 5.47608 16.4597 3.55749 15.8094C2.53014 15.4612 1.65484 15.041 0.939117 14.5533V20.4713C0.939117 21.6343 1.88524 22.5804 3.04818 22.5804H20.9517C22.1147 22.5804 23.0608 21.6343 23.0608 20.4713V14.5532C20.271 16.3129 17.1731 16.7452 13.4309 16.9688Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M11.8827 15.9719H12.1171C12.6229 15.9755 13.0336 15.5483 13.031 15.058V14.144H10.9688V15.058C10.9688 15.2367 11.0303 15.4325 11.1341 15.5806C11.2996 15.8168 11.5732 15.9719 11.8827 15.9719Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_459_2811">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            {stringsoflanguages.myportfolio}
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Global Portfolio" ? "active" : ""}`}
                        onClick={() => setActiveItem("Global Portfolio")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{portfolioPoolCount}</span>
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_459_2821)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M16.1661 0.515625L10.8189 2.80139V21.7495H12.4469V17.7664L12.0701 17.8023C11.916 17.8168 11.7793 17.7037 11.7647 17.5496C11.7502 17.3955 11.8633 17.2587 12.0174 17.2441L14.9149 16.9684C15.069 16.9538 15.2057 17.067 15.2203 17.2211C15.2348 17.3752 15.1217 17.5119 14.9676 17.5265L14.5382 17.5673V21.7494H21.5132V2.80139L16.1661 0.515625ZM12.9165 15.2134L11.9058 15.3101V13.3572L12.9165 13.2014V15.2134ZM12.9169 12.0411L11.9059 12.231V10.2735L12.9169 10.0243V12.0411ZM12.9169 8.86725L11.9059 9.15042V7.19283L12.9169 6.85041V8.86725ZM12.9169 5.69175L11.9059 6.06666V4.23783L12.9172 3.80433L12.9169 5.69175ZM15.0792 15.0074L13.9403 15.1165V13.0413L15.0792 12.8654V15.0074ZM15.0792 11.6322L13.9403 11.8465V9.77292L15.0792 9.49186V11.6321V11.6322ZM15.0792 8.25867L13.9403 8.57812V6.50287L15.0792 6.11667V8.25867ZM15.0792 4.88517L13.9403 5.30972L13.9399 3.36614L15.0791 2.87737V4.88517H15.0792ZM17.7841 18.4219C17.7841 18.5773 17.6582 18.7032 17.5029 18.7032C17.3475 18.7032 17.2216 18.5773 17.2216 18.4219V2.9722C17.2216 2.81686 17.3475 2.69095 17.5029 2.69095C17.6582 2.69095 17.7841 2.81686 17.7841 2.9722V18.422V18.4219ZM19.1209 18.4219C19.1209 18.5773 18.995 18.7032 18.8397 18.7032C18.6843 18.7032 18.5584 18.5773 18.5584 18.4219V3.54366C18.5584 3.38831 18.6844 3.26241 18.8397 3.26241C18.995 3.26241 19.1209 3.38836 19.1209 3.54366V18.422V18.4219ZM20.4577 18.4219C20.4577 18.5773 20.3318 18.7032 20.1765 18.7032C20.0211 18.7032 19.8952 18.5773 19.8952 18.4219V4.11511C19.8952 3.95977 20.0211 3.83386 20.1765 3.83386C20.3318 3.83386 20.4577 3.95977 20.4577 4.11511V18.422V18.4219ZM8.05491 6.03591L2.48681 8.41613V21.7495H4.22522V18.657L3.84849 18.6929C3.69436 18.7074 3.55763 18.5943 3.5431 18.4402C3.52856 18.2861 3.64167 18.1493 3.7958 18.1348L6.69324 17.859C6.84736 17.8445 6.98409 17.9576 6.99867 18.1117C7.0132 18.2659 6.90009 18.4026 6.74597 18.4172L6.31655 18.4581V21.7495H10.2565V6.97702L8.05491 6.03591ZM4.49911 15.78L3.6765 15.8926V14.3092L4.49911 14.1402V15.78ZM4.49911 13.199L3.6765 13.4013V11.8178L4.49911 11.5592V13.199ZM4.49939 10.617L3.67655 10.908V9.42905L4.49967 9.08236L4.49939 10.617ZM6.28791 15.533L5.34052 15.6635V13.9677L6.28791 13.7722V15.533ZM6.28791 12.7573L5.34052 12.9907V11.2938L6.28791 10.9944V12.7573ZM6.28791 9.98053L5.34024 10.3178V8.72878L6.28791 8.3272V9.98053ZM0.541595 22.312H23.4584V23.4844H0.541595V22.312Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_459_2821">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            {stringsoflanguages.globalPortfolio}
                        </div>
                        <div className="sidebar-filter-status flex flex-col text-center">
                            <span className="view-details">{stringsoflanguages.viewDetails}</span>
                            {portfolioFilterStatus === 1 ? <span className="sidebar-filter-active">{stringsoflanguages.filterActive}</span> : null}
                        </div>
                    </div>
                </li>
            </ul>

            {/* <Footer /> */}
        </div>
    );
}

